import React from 'react'
import Loading from './Loading'

interface IButton extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    loading?: boolean
    text?: string
    disabled?: boolean
}

const Button = React.memo((props: IButton) => {
    return <button
        {...props}
        className="btn btn-block d-flex justify-content-center align-items-center"
    >
        <span>{props.text || 'Button'}</span>
        <div className="mr-2"></div>
        {props.loading ? <Loading /> :''}
    </button>
})

export default Button